<template>
  <div class="delivery-block">
    <header>
      <h3>Angaben zur Vermarktung</h3>
    </header>

    <b-form-group>
      <b-form-checkbox-group
        v-model="data.qualityProgramIds"
        :options="programs"
        :disabled="disabled || saving"
        stacked
      />
      <b-form-checkbox
        v-model="data.qualityProgramIds"
        label="Anderes"
        :value="0"
        :disabled="disabled || saving">
        Anderes
      </b-form-checkbox>

      <div v-if="data.qualityProgramIds.includes(0)" class="mt-2">
        <b-input v-model="data.qualityProgram"/>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import {computed, ref, watch} from '@vue/composition-api'
import ModalSelectFactory from "@/app/components/delivery/ModalSelectFactory.vue";

export default {
  components: {ModalSelectFactory},
  props: {
    value: { type: Object, required: true },
    disabled: { type: Boolean, required: true },
    saving: { type: Boolean, required: true },
  },

  setup(props, { emit }) {
    const store = window.useStore()

    const data = ref(props.value)

    watch(data, () => {
      emit('change', data)
    }, { deep: true })

    const programs = computed(() => {
      return store.state.pwa.deliveries.piglet.config.qualityPrograms.data
        .map(t => ({
          text: t.name,
          value: t.id
        }))
    })

    return {
      data,
      programs,
    }
  }
}
</script>
